"use client";
import CWFButton from "@/components/ui/CWFButton";
import React, { useCallback, useEffect, useState } from "react";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import getStripe from "@/lib/utils/get-stripe";
import {useSubscription} from "@/lib/hooks/useSouscription";
import {reworkDate} from "@/lib/helpers/reworkDate";
import {FaCheck} from "react-icons/fa";

import { useSession } from "next-auth/react";
import AuthAction from "@/components/site/AuthAction";

export default function PaymentSubscriptionButton({label, priceId, className}) {
    const { data: session, status } = useSession();
    const axios = useAxiosAuth();
    const [pendingCheckout, setPendingCheckout] = useState(false);

    const {
        subscription,
        availablePlans,
        isLoadingPlans,
        isLoadingSubscription,
    } = useSubscription();

    const subscribe = useCallback(async () => {
        try {
            const stripe = await getStripe();
            const response = await axios.post(`subscriptions/checkout`, {
                price_id : priceId,
                success_url: process.env.NEXT_PUBLIC_URL + '/dashboard/subscriptions',
                cancel_url: process.env.NEXT_PUBLIC_URL + '/tarifs',
            });

            const data = response.data.data;

            if(!data) throw new Error('Something went wrong');

            await stripe.redirectToCheckout({
                sessionId: data.id
            });
        } catch (error) {
            console.error('Subscription error:', error);
            setPendingCheckout(false);
        }
    }, [axios, priceId]);

    // Effet pour gérer la souscription après authentification
    useEffect(() => {
        if (pendingCheckout && status === "authenticated" && session) {
            subscribe();
            setPendingCheckout(false);
        }
    }, [pendingCheckout, status, session, subscribe]);

    const handleAuthSuccess = () => {
        // Marquer qu'on veut faire un checkout après connexion
        setPendingCheckout(true);
    };

    if(isLoadingPlans || isLoadingSubscription) return <></>;

    if(subscription?.local && subscription.local.stripe_price_id === priceId){
        return(
            <div className={"flex items-center justify-center gap-x-2 font-semibold text-xs"}>
                <FaCheck className={"text-primary"} size={16}/>
                <p>Votre offre depuis le <span className={"text-primary"}>{reworkDate(subscription?.local?.current_period_start)}</span></p>
            </div>
        )
    }

    return(
        <AuthAction
            action={handleAuthSuccess}
            trigger={
                <CWFButton className={className}>
                    {label}
                </CWFButton>
            }
        />
    )
}